import styled from 'styled-components';

export const MeterWrap = styled.div`
  position: absolute;
  top: -25%;
  width: 98%;
  margin-left: 1%;
`;
